module.exports = __webpack_public_path__ + "img/pattern-left-1.f9722fe2.png";